// Auto-generated by scripts/generate-version.js — do not edit
export const BUILD_HASH = "b41a5257bcc4";
export const BUILD_VERSION_NUMBER = 42;
